<template>
    <div class="row">
        <div class="col-lg-6">
            <div class="row">
                <div class="col-lg-2 col-form-label" style="text-align: left">
                    {{ keyLabel }}
                </div>
                <div class="col-lg-10">
                    <input v-if="isExist" class="form-control" v-model="key" @change="updateToParent(0)" style="background-color: #fffc83">
                    <input v-else class="form-control" v-model="key" @change="updateToParent(0)">
                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="row">
                <div class="col-lg-2 col-form-label" style="text-align: left">
                    {{ keyRemarksLabel }}
                </div>
                <div class="col-lg-10">
                    <input class="form-control" v-model="keyRemarks" @change="updateToParent(1)">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from "@vueform/multiselect";

export default {
    name: "TopDataKeyBox",
    components: {
        Multiselect,
    },
    props: {
        keyLabel: '',
        keyRemarksLabel: '',
        mode: '',
    },
    data(){
        return{
            key: '',
            keyRemarks: '',

            isExist: false,
            existModelData: '',
        }
    },
    methods: {
        async updateFromParent(dnName){
            this.key = dnName
            await this.updateToParent(0)
        },
        async updateToParent(flag) {
            if(flag === 0){
                await this.getDuplicate()
                this.$emit('returnData', {
                    "key": this.key,
                    "keyRemarks": this.keyRemarks,
                    "isExist": this.isExist,
                    "existModelData": this.existModelData
                })
            }else{
                this.$emit('returnData', {
                    "key": this.key,
                    "keyRemarks": this.keyRemarks,
                    "isExist": false,
                })
            }

        },
        async getDuplicate(){
            await this.$mainApi.get(`api/inventory/key-check?mode=${this.mode}&key=${this.key}`)
                .then(response => {
                    if(response.data.status === 80){
                        if(response.data.details.exist === true){
                            this.isExist = true
                            this.existModelData = response.data.details.details
                            this.keyRemarks = response.data.details.details.remarks
                        }
                    }
                })
        }
    },
    mounted(){
        let now = new Date()
        const offset = now.getTimezoneOffset()
        now = new Date(now.getTime() - (offset*60*1000))
        let title = ""
        switch(this.mode){
            case 'stock_in':
                title = "PO_"
                break
            case 'stock_out':
                title = "DN_"
                break
            case 'stock_tran':
                title = "Stock_Transfer_"
                break
            case 'write_off':
                title = "Write_Off_"
                break
        }
        this.key = title + now.toISOString().substring(0,19).toString()
        this.updateToParent()
    }
}
</script>

<style scoped>

</style>
